import { Background } from "./Background";
import { MysticHeader } from "./MysticHeader";

export const Layout = ({ children }) => (
  <div className="App">
    <Background />
    <MysticHeader />
    {children}
    <footer className="no-print relative z-10 max-w-3xl mx-auto px-6 py-12 text-center">
      <a
        data-testid="footer-website-link"
        href="https://samantha-hellsehen-kartenlegen.de"
        target="_blank"
        rel="noopener noreferrer"
        className="serif inline-block text-lg font-semibold text-[#b8860b] hover:text-[#D4AF37] transition-colors"
      >
        Samantha – Hellsehen &amp; Kartenlegen
      </a>
      <p className="serif text-[15px] text-[#6b4f12] mt-0.5 mb-5">
        Dein Weg ins Licht · samantha-hellsehen-kartenlegen.de
      </p>
      <p className="text-[14px] leading-[1.6] text-[#6b6354] italic">
        Wenn die App vollständig eingerichtet ist, stelle bitte den Link zur
        Webseite oder App‑Ansicht öffentlich bereit, damit alle Nutzer direkt
        darauf zugreifen können.
      </p>
      <p className="text-[13px] text-[#9a8f78] mt-6">
        Erstellt mit{" "}
        <a
          data-testid="emergent-credit-link"
          href="https://emergent.sh"
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-[#b8860b] hover:text-[#D4AF37] transition-colors"
        >
          Emergent
        </a>
      </p>
    </footer>
  </div>
);
